/**
 * Apartsales — Tab 2 (Корзина / Cart).
 *
 * Phase 1 spec: docs/architecture/25-screen-architecture-and-navigation.md §4.
 * Active Lock 🔒 entries + shortlist + Grab-style cart for multi-unit deals.
 *
 * For now: placeholder explaining what will be here.
 */

import { createFileRoute } from '@tanstack/react-router';
import { TabStub } from '~/components/TabStub';

export const Route = createFileRoute('/cart')({
  component: CartPage,
});

function CartPage() {
  return (
    <TabStub
      title="Корзина"
      subtitle="Активные Lock 🔒 и shortlist"
      description="Здесь появятся ваши зафиксированные юниты, отложенные варианты и Grab-style корзина для multi-unit сделок. Раздел в разработке — следующая итерация."
      docRef="docs/architecture/25 §4"
    />
  );
}
